<template>
  <v-container>
    <v-card class="px-2">
      <input
        id="user-id"
        type="hidden"
        v-model="agenda.usuario"
      >
      <input
        id="agenda-uuid"
        type="hidden"
        v-model="agenda.id"
      >
      <input
        id="agenda-id"
        type="hidden"
        v-model="agenda.uuid"
      >
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="codigo"
            label="Código"
            dense
            outlined
            @change="loadAgenda()"
          >
            <v-btn
              class="btn-outer-right pa-0"
              slot="append"
              color="success"
              tile
              @click.prevent="loadDialog"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="3"
          lg="2"
          v-if="codigo"
        >
          <v-checkbox
            v-model="agenda.inativar"
            label="Inativar agenda?"
            color="success"
            v-show="mode === 'save'"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          colls="12"
          lg="2"
          md="3"
          sm="12"
        >
          <v-text-field
            label="Dia.:"
            v-model="agenda.dia"
            required
            :readonly="mode === 'delete'"
            dense
            outlined
          >
          </v-text-field>
        </v-col>
        <v-col
          colls="12"
          lg="3"
          md="3"
          sm="12"
        >
          <v-autocomplete
            label="Mês.:"
            v-model="agenda.mes"
            :readonly="mode === 'delete'"
            :items="meses"
            dense
            outlined
          >
          </v-autocomplete>
        </v-col>
        <v-col
          colls="12"
          lg="2"
          md="3"
          sm="12"
        >
          <v-text-field
            label="Ano.:"
            v-model="agenda.ano"
            required
            :readonly="mode === 'delete'"
            dense
            outlined
          >
          </v-text-field>
        </v-col>
        <v-col
          colls="12"
          lg="3"
          md="3"
          sm="12"
        >
          <v-autocomplete
            label="Dia da semana.:"
            v-model="agenda.semana"
            :readonly="mode === 'delete'"
            :items="semana"
            dense
            outlined
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-card flat>
        <v-tabs
          background-color="primary"
          dark
          v-model="tabs"
          class="mb-4"
        >
          <v-tab>
            <v-icon class="mr-1">
            </v-icon>
            Geral
          </v-tab>
          <v-tab @click.prevent="Eventos()">
            <v-icon class="mr-1">
            </v-icon>
            Eventos
          </v-tab>
          <v-tab @click.prevent="loadDepartamentos()">
            <v-icon class="mr-1">
            </v-icon>
            Departamentos
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card
              flat
              class="py-2"
            >
              <v-row>
                <v-col
                  colls="12"
                  lg="10"
                  md="12"
                  sm="12"
                >
                  <v-text-field
                    label="Título.:"
                    v-model="agenda.titulo"
                    required
                    :readonly="mode === 'delete'"
                    dense
                    outlined
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col colls="12">
                  <v-card class="pa-2">
                    <ckeditor
                      :editor="editor"
                      v-model="agenda.ds_agenda"
                      :config="editorConfig"
                      placeholder="Observação..."
                      :readonly="mode === 'delete'"
                    ></ckeditor>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-data-table
                      :headers="headerMovim"
                      :items="movimentos"
                      :search="search"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          large
                          color="success"
                          class="mr-2"
                          @click="loadNotificacoes(item, mode='update')"
                        >
                          mdi-calendar-text
                        </v-icon>
                        <v-icon
                          large
                          color="primary"
                          class="mr-2"
                          @click="loadMovim(item, mode='update')"
                        >
                          mdi-square-edit-outline
                        </v-icon>
                        <v-icon
                          large
                          color=""
                          class="mr-2"
                          @click="loadAddDpto(item)"
                        >
                           mdi-account-group-outline
                      </v-icon>
                      </template>
                    </v-data-table>
                    <v-card-actions class="justify-end">
                      <v-btn
                        color="success"
                        class="ml-1 mb-3"
                        v-if="codigo"
                        @click="loadModalMovim"
                      >
                        <v-icon left>
                          mdi-archive-arrow-up-outline
                        </v-icon>
                        Add evento
                      </v-btn>
                      <v-btn
                        color="success"
                        class="ml-1 mb-3"
                        v-if="codigo"
                        @click="addNotificacao"
                      >
                        <v-icon left>
                          mdi-archive-arrow-up-outline
                        </v-icon>
                        Add Notificação
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <!-- Grid de departamentos -->
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-data-table
                      :headers="headerDepto"
                      :items="departamentos"
                      :search="search"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon v-if="item.inativar === 1" medium color="primary" class="mr-2"
                            @click="loadActiveDpto(item)">
                            mdi-eye-off-outline
                          </v-icon>
                          <v-icon v-else medium color="primary" class="mr-2" @click="loadInactiveDpto(item)">
                            mdi-eye-outline
                          </v-icon>
                        <v-icon medium color="error" class="mr-2" @click="delDpto(item)">
                            mdi-delete
                          </v-icon>
                      </template>
                    </v-data-table>
                    <v-card-actions class="justify-end">
                      <v-btn
                        color="success"
                        class="ml-1 mb-3"
                        v-if="codigo"
                        @click="addDptoAgenda"
                      >
                        <v-icon left>
                          mdi-archive-arrow-up-outline
                        </v-icon>
                        Add departamento
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-card-actions>
          <v-row class="mt-1">
            <v-col
              cols="12"
              md="6"
            >
              <v-btn
                color="success"
                class="ml-1 mr-4"
                v-if="mode === 'save'"
                @click.prevent="save"
              >
                <v-icon left>
                  mdi-content-save-outline
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="success"
                class="ml-1 mr-4"
                v-if="mode === 'update'"
                @click.prevent="update"
              >
                <v-icon left>
                  mdi-content-save-edit-outline
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="secondary"
                class="mr-4"
                @click="reset"
              >
                <v-icon left>
                  mdi-broom
                </v-icon>
                Limpar
              </v-btn>
              <v-btn
                v-if="agenda.id"
                color="error"
                class="mr-4"
                @click="remove"
              >
                <v-icon left>
                  mdi-trash-can-outline
                </v-icon>
                Deletar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <!-- Dialog de notificações -->
      <v-container>
        <v-dialog
          v-model="dialogNotificacoes"
          transition="dialog-top-transition"
        >
          <v-card
            tile
            min-height="500"
          >
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              <v-icon class="mr-2">
                mdi-pencil-box-outline
              </v-icon>
              Adicionar ou editar compromissos no calendário
            </v-toolbar>
            <v-form>
              <div class="ma-2 pt-5 px-2">
                <input
                  id="user-id"
                  type="hidden"
                  v-model="notifica.usuario"
                >
                <input
                  id="agenda-uuid"
                  type="hidden"
                  v-model="notifica.id"
                >
                <input
                  id="agenda-id"
                  type="hidden"
                  v-model="notifica.uuid"
                >
                <input
                  id="agenda-id"
                  type="hidden"
                  v-model="notifica.uid_evento"
                >
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codNotific"
                      label="Cod. notificação"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="3"
                    v-if="codNotific"
                  >
                    <v-checkbox
                      v-model="notifica.inativar"
                      label="Inativar notificação?"
                      color="success"
                    ></v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="3"
                    v-if="codNotific"
                  >
                    <v-checkbox
                      v-model="notifica.publicar"
                      label="publicar notificação?"
                      color="success"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codEvent"
                      label="Evento"
                      dense
                      outlined
                      @change="loadEvent()"
                    >
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click.prevent="loadDialogEvent"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="10"
                    md="10"
                    sm="12"
                  >
                    <v-text-field
                      label="Título.:"
                      v-model="notifica.titulo"
                      required
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    colls="12"
                    lg="6"
                    md="7"
                    sm="12"
                  >
                    <v-text-field
                      label="Url interna.:"
                      v-model="notifica.url_int"
                      required
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="2"
                    md="3"
                    sm="12"
                  >
                    <v-text-field
                      label="Data do evento.:"
                      v-model="data_do_evento"
                      required
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="2"
                    md="3"
                    sm="12"
                  >
                    <v-text-field
                      label="Fim do evento.:"
                      v-model="fim_do_evento"
                      required
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-checkbox
                      v-model="notifica.publicar"
                      label="Publicar notificação?"
                      color="success"
                      v-show="mode === 'save'"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="ml-1 mb-3"
                    v-if="notifica.titulo"
                    @click="saveNotificacao"
                  >
                    <v-icon left>
                      mdi-reload
                    </v-icon>
                    Sincronizar
                  </v-btn>
                  <v-btn
                    v-if="notifica.id"
                    color="error"
                    class="ml-1 mb-3"
                    @click="delNotificacao"
                  >
                    <v-icon left>
                      mdi-trash-can-outline
                    </v-icon>
                    Deletar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="ml-1 mb-3"
                    @click="closeDialog"
                  >Fechar</v-btn>
                </v-card-actions>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialogo de filtro da agenda -->
      <v-container>
        <v-dialog
          v-model="dialogFilter"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialogFilter">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headerAgenda"
                :items="agendas"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    large
                    color="success"
                    class="mr-2"
                    @click.prevent="loadAgenda(item, mode='update')"
                  >
                    mdi-arrow-down-bold-box
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialogFilter.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Dialogo de filtro de departamentos -->
      <v-container>
        <v-dialog
          v-model="dialogFDpto"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialogFDpto">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headerDpto"
                :items="listDptos"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    large
                    color="success"
                    class="mr-2"
                    @click.prevent="loadUnidade(item)"
                  >
                    mdi-arrow-down-bold-box
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialogFDpto.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Dialog do filtro de eventos -->
      <v-container>
        <v-dialog
          v-model="dialogFilterEvent"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialogFilterEvent">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headerEvent"
                :items="eventos"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    large
                    color="success"
                    class="mr-2"
                    @click.prevent="loadEvent(item)"
                  >
                    mdi-arrow-down-bold-box
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialogFilterEvent.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Dialog de movimento -->
      <v-container>
        <v-dialog
          v-model="DialogMovimento"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              Adicionar ou editar eventos na agenda
            </v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="movimento.usuario"
                />
                <input
                  id="uuid-id"
                  type="hidden"
                  v-model="movimento.uid_agenda"
                />
                <input
                  id="movimento-id"
                  type="hidden"
                  v-model="movimento.id"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codigo"
                      label="Código"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="3"
                    md="4"
                    v-if="movimento.id"
                  >
                    <v-checkbox
                      v-model="movimento.inativar"
                      label="Inativar Evento?"
                      color="success"
                      class="mt-4"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    colls="12"
                    lg="3"
                    md="4"
                  >
                    <v-autocomplete
                      label="Categoria:"
                      v-model="movimento.uid_categoria"
                      :items="categorias"
                      dense
                      outlined
                      @change="loadSubCategorias()"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="3"
                    md="4"
                  >
                    <v-autocomplete
                      label="Subcategoria:"
                      v-model="movimento.uid_subcategoria"
                      :items="subcategorias"
                      dense
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="3"
                    md="4"
                  >
                    <v-autocomplete
                      label="Tipo de evento:"
                      v-model="movimento.tipo_agenda"
                      :items="tipoEvento"
                      dense
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                    lg="3"
                  >
                    <v-text-field
                      v-model="movimento.local"
                      type="text"
                      label="Local do evento"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    lg="3"
                  >
                    <v-text-field
                      v-model="movimento.proponente"
                      type="text"
                      label="Proponente"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    lg="3"
                  >
                    <v-text-field
                      v-model="movimento.coordenador"
                      type="text"
                      label="Coordenador"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-mask="datacad"
                          v-model="data_cad"
                          label="Data início do evento.:"
                          dense
                          outlined
                          @blur="mudaDataA"
                        >
                          <v-icon
                            slot="append"
                            color="success"
                            large
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-br"
                        v-model="date0"
                        @input="dateA"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-mask="datafim"
                          v-model="data_fim"
                          label="Data final do evento.:"
                          dense
                          outlined
                          @blur="mudaDataC"
                        >
                          <v-icon
                            slot="append"
                            color="success"
                            large
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-br"
                        v-model="date2"
                        @input="dateC"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-text-field
                      v-model="movimento.hora_inicio"
                      type="text"
                      label="Hora início"
                      v-mask="horaini"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-text-field
                      v-model="movimento.hora_fim"
                      type="text"
                      label="Término do evento"
                      v-mask="horafim"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="1"
                  >
                    <v-text-field
                      v-model="movimento.color"
                      type="color"
                      label="Cor"
                      outlined
                      dense
                    >
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        :color="movimento.color"
                      >
                        <v-icon
                          large
                          class="mx-0"
                          :color="movimento.color ? 'white' : ''"
                        >mdi-invert-colors</v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    lg="10"
                  >
                    <v-text-field
                      v-model="movimento.titulo"
                      type="text"
                      label="Título"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col colls="12">
                    <v-card class="pa-2">
                      <ckeditor
                        :editor="editor"
                        v-model="movimento.ds_agenda"
                        :config="editorConfig"
                        placeholder="Observação..."
                        :readonly="mode === 'delete'"
                      ></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="movimento.id"
                type="submit"
                @click.prevent="saveMov()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!movimento.id"
                type="submit"
                @click.prevent="saveMov()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="movimento.id"
                @click="delMovimento"
              >
                deleter
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog de departamentos por evento-->
      <v-container>
        <v-dialog
          v-model="dialogDpto"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              Adicionar ou editar departamentos
            </v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="departamento.usuario"
                />
                <input
                  id="agenda-id"
                  type="hidden"
                  v-model="departamento.uid_agenda"
                />
                <input
                  id="departamento-id"
                  type="hidden"
                  v-model="departamento.uid_magenda"
                />
                <input
                  id="unidade-id"
                  type="hidden"
                  v-model="departamento.uid_unidade"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="cdDpto"
                      label="Código"
                      dense
                      outlined
                    >
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click.prevent="filtroUnidades"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    md="6"
                  >
                  <h5><span>Departamento</span><br /><span>{{ depto }}</span></h5>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-mask="datacad"
                          v-model="data_cad"
                          label="Data início do evento.:"
                          dense
                          outlined
                          @blur="mudaDataA"
                        >
                          <v-icon
                            slot="append"
                            color="success"
                            large
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-br"
                        v-model="date0"
                        @input="dateA"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-mask="datafim"
                          v-model="data_fim"
                          label="Data final do evento.:"
                          dense
                          outlined
                          @blur="mudaDataC"
                        >
                          <v-icon
                            slot="append"
                            color="success"
                            large
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-br"
                        v-model="date2"
                        @input="dateC"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-text-field
                      v-model="departamento.hora_inicio"
                      type="text"
                      label="Hora início"
                      v-mask="horaini"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-text-field
                      v-model="departamento.hora_fim"
                      type="text"
                      label="Término do evento"
                      v-mask="horafim"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    lg="10"
                  >
                    <h5><span>Descrição do evento</span><br /><span>{{ dsevento }}</span></h5>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="departamento.id"
                type="submit"
                @click.prevent="saveDpto()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!departamento.id"
                type="submit"
                @click.prevent="saveDpto()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="departamento.id"
                @click="delDpto"
              >
                deleter
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="closeDpto"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog de departamentos com eventos-->
      <v-container>
        <v-dialog
          v-model="dialogDptoEv"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              Adicionar ou editar departamentos com eventos
            </v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="departamento.usuario"
                />
                <input
                  id="uuid-id"
                  type="hidden"
                  v-model="departamento.uid_agenda"
                />
                <input
                  id="unidade-id"
                  type="hidden"
                  v-model="departamento.uid_unidade"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="cdDpto"
                      label="Código"
                      dense
                      outlined
                    >
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click.prevent="filtroUnidades"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    md="6"
                  >
                  <h5><span>Departamento</span><br /><span>{{ depto }}</span></h5>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    lg="10"
                  >
                    <h5><span>Título da agenda</span><br /><span>{{ dsagenda }}</span></h5>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                  <h4>Aqui vai a grid dos eventos</h4>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="departamento.id"
                type="submit"
                @click.prevent="saveDpto()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!departamento.id"
                type="submit"
                @click.prevent="syncAgendaUnidade()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="departamento.id"
                @click="delDpto"
              >
                deleter
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="closeDptoEv"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'
import moment from 'moment'
import { isSealed } from 'core-js/core/object'
export default {
  name: 'agendaMovin',
  computed: mapState(['user']),

  data: function () {
    return {
      errors: {},
      editor: ClassicEditor,
      editorConfig: {},
      data_do_evento: null,
      fim_do_evento: null,
      datacad: '##/##/####',
      datenc: '##/##/####',
      datafim: '##/##/####',
      horaini: '##:##',
      horafim: '##:##',
      mode: 'save',
      depto: '[ Departamento não informado! ]',
      dsevento: '[ Evento não selecionado! ]',
      dsagenda: '[ Agenda não selecionada! ]',
      tabs: null,
      codigo: '',
      cdDpto: '',
      codEvent: '',
      codNotific: '',
      dialogFilter: false,
      dialogFDpto: false,
      dialogNotificacoes: false,
      dialogFilterEvent: false,
      DialogMovimento: false,
      dialogDpto: false,
      dialogDptoEv: isSealed,
      date0: new Date().toISOString().substr(0, 10),
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      data_cad: '',
      data_enc: '',
      data_fim: '',
      menu: false,
      menu1: false,
      menu2: false,
      search: null,
      uuid: '',
      agenda: {},
      agendas: [],
      categorias: [],
      subcategorias: [],
      movimento: {},
      notific: {},
      notifica: {},
      menuunidade: {},
      departamento: {},
      departamentos: [],
      movimentos: [],
      eventos: [],
      loading: false,
      filter: null,
      filterOn: [],
      listDptos: [],
      headerAgenda: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Dias semana', value: 'semana' },
        { text: 'Dia', value: 'dia' },
        { text: 'Mês', value: 'mes' },
        { text: 'Ano', value: 'ano' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerDpto: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Departamento', value: 'unidade' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerEvent: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Data', value: 'inicio' },
        { text: 'Hora', value: 'hora_inicio' },
        { text: 'Término', value: 'fim' },
        { text: 'título', value: 'titulo' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerMovim: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Título', value: 'titulo' },
        { text: 'Data final', value: 'datafim' },
        { text: 'Hora início', value: 'hora_inicio' },
        { text: 'Hora fim', value: 'hora_fim' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerDepto: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Departamento', value: 'unidade' },
        { text: 'dia', value: 'dia' },
        { text: 'Descrição da agenda', value: 'titulo' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      tipoEvento: [
        { value: 'Aberto ao Público', text: 'Aberto ao Público' }
      ],
      meses: [],
      semana: []
    }
  },
  methods: {
    mudaDataA () {
      const [dia, mes, ano] = this.data_cad.split('/')
      if (this.data_cad) {
        this.movimento.data = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateA () {
      this.data_cad = moment(this.date0).format('DD/MM/YYYY')
      this.menu = false
      const [dia, mes, ano] = this.data_cad.split('/')
      this.movimento.data = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataB () {
      const [dia, mes, ano] = this.data_enc.split('/')
      if (this.data_enc) {
        this.agenda.data_encerramento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateB () {
      this.data_enc = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
      const [dia, mes, ano] = this.data_enc.split('/')
      this.agenda.data_encerramento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataC () {
      const [dia, mes, ano] = this.data_fim.split('/')
      if (this.data_fim) {
        this.movimento.data_fim = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateC () {
      this.data_fim = moment(this.date2).format('DD/MM/YYYY')
      this.menu1 = false
      const [dia, mes, ano] = this.data_fim.split('/')
      this.movimento.data_fim = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    save () {
      const mode = this.mode
      const method = this.agenda.id ? 'put' : 'post'
      const id = this.agenda.id ? `/${this.agenda.id}` : ''
      axios[method](`${baseApiUrl}/agenda${id}`, this.agenda)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          if (mode === 'save') {
            this.reset()
          }
        })
        .catch(showError)
    },
    update () {
      const method = this.agenda.id ? 'put' : 'post'
      const id = this.agenda.id ? `/${this.agenda.id}` : ''
      axios[method](`${baseApiUrl}/agenda-update${id}`, this.agenda)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadAgenda()
        })
        .catch(showError)
    },
    remove () {
      const id = this.agenda.id
      if (confirm('Deseja realmente deletar esta agenda?')) {
        axios.delete(`${baseApiUrl}/agendass-do-dia/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.reset()
          })
          .catch(showError)
      }
    },
    saveMov () {
      const method = this.movimento.id ? 'put' : 'post'
      const id = this.movimento.id ? `/${this.movimento.id}` : ''
      axios[method](`${baseApiUrl}/movimento-da-agenda${id}`, this.movimento)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.clearMovimento()
          this.loadMovimento()
          this.DialogMovimento = false
        })
        .catch(showError)
    },
    delMovimento () {
      const id = this.movimento.id
      if (confirm('Deseja realmente deletar este evento?')) {
        axios.delete(`${baseApiUrl}/movimento-da-agenda/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.reset()
          })
          .catch(showError)
      }
    },
    saveDpto () {
      const method = this.departamento.id ? 'put' : 'post'
      const id = this.departamento.id ? `/${this.departamento.id}` : ''
      axios[method](`${baseApiUrl}/departamento-por-evento${id}`, this.departamento)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.clearDpto()
          this.loadDepartamento()
          this.dialogDpto = false
        })
        .catch(showError)
    },
    syncAgendaUnidade () {
      const method = this.departamento.id ? 'put' : 'post'
      axios[method](`${baseApiUrl}/agenda-unidades/sync`, this.departamento)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.clearDpto()
          this.loadDepartamento()
          this.dialogDptoEv = false
        })
        .catch(showError)
    },

    delDpto (item) {
      const method = 'delete'
      axios[method](`${baseApiUrl}/agenda-unidades/remove`, {
        data: { uid_agenda: item.uid_agenda,
                uid_unidade: item.uid_unidade
        }
      })
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadDepartamentos()
        })
        .catch(showError)
    },

    delEvento (item) {
      axios.delete(`${baseApiUrl}/agenda-evento-remove/${item.id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadDepartamentos()
        })
        .catch(showError)
    },

    updateDpto () {
      const method = 'post'
        axios[method](`${baseApiUrl}/agenda-unidades/update`, this.menuunidade)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadDepartamentos()
          })
          .catch(showError)
    },
    saveNotificacao () {
      const method = this.notifica.id ? 'put' : 'post'
      const id = this.notifica.id ? `/${this.notifica.id}` : ''
      axios[method](`${baseApiUrl}/notificacoes${id}`, this.notifica)
        .then(() => {
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    delNotificacao () {
      const id = this.notifica.id
      if (confirm('Deseja realmente deletar a notificação do evento?')) {
        axios.delete(`${baseApiUrl}/notificacoes/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.reset()
          })
          .catch(showError)
      }
    },
    FecharDialog () {
      this.DialogMovimento = false
      this.clearMovimento()
    },
    closeDpto () {
      this.dialogDpto = false
      this.departamento = {}
      this.cdDpto = ''
      this.depto = ''
      this.dsevento = ''
    },
    closeDptoEv () {
      this.dialogDptoEv = false
      this.departamento = {}
      this.cdDpto = ''
      this.depto = ''
      this.dsagenda = ''
    },
    clearMovimento () {
      this.movimento = {}
      this.movimento.usuario = this.user.id
      this.movimento.uid_agenda = this.agenda.id
    },
    clearDpto () {
      this.departamento = {}
      this.departamento.usuario = this.user.id
      this.departamento.uid_agenda = this.agenda.id
      this.cdDpto = ''
      this.depto = ''
      this.dsagenda = ''
      this.dsevento = ''
    },
    reset () {
      this.mode = 'save'
      this.codigo = ''
      this.codEvent = ''
      this.codNotific = ''
      this.agenda = {}
      this.notific = {}
      this.notifica = {}
      this.data_cad = ''
      this.data_enc = ''
      this.agendas = []
      this.eventos = []
      this.departamentos = []
      this.movimentos = []
      this.agenda.usuario = this.user.id
      this.agenda.uuid = uuid.v1()
    },
    loadAgenda (item, mode) {
      const mod = mode || this.mode
      const id = this.codigo ? this.codigo : item.id
      const url = `${baseApiUrl}/agenda-select-update/${id}`
      axios.get(url).then(res => {
        this.agenda = res.data
        this.codigo = this.agenda.id
        //        this.loadMovims()
      })
      this.mode = mod
      this.dialogFilter = false
    },
    loadModalMovim () {
      this.movimento.usuario = this.user.id
      this.movimento.uid_agenda = this.agenda.id
      this.DialogMovimento = true
      this.loadCategorias()
    },
    loadAddDpto (item) {
      this.departamento.usuario = this.user.id
      this.departamento.uid_agenda = this.agenda.id
      this.departamento.uid_magenda = item.id
      this.dsevento = item.titulo
      this.dialogDpto = true
    },
    addDptoAgenda () {
      this.departamento.usuario = this.user.id
      this.departamento.uid_agenda = this.agenda.id
      this.dsagenda = this.agenda.titulo
      this.dialogDptoEv = true
    },
    Eventos () {
      this.loadMovimento()
    },
    loadEvent (item) {
      const id = this.codEvent ? this.codEvent : item.id
      const url = `${baseApiUrl}/movimento-da-agenda-select-notificate-update/${id}`
      axios.get(url).then(res => {
        this.notific = res.data
        this.codEvent = this.notific.id
        this.notifica.usuario = this.user.id
        this.notifica.uid_page = this.agenda.uuid
        this.notifica.uuid = uuid.v1()
        this.notifica.uid_evento = this.notific.id
        this.data_do_evento = moment(this.notific.data).format('DD/MM/YYYY')
        this.fim_do_evento = moment(this.notific.data_fim).format('DD/MM/YYYY')
        this.notifica.data_evento = moment(this.notific.data).format('YYYY-MM-DD')
        this.notifica.fim_evento = moment(this.notific.data_fim).format('YYYY-MM-DD')
        const sub = this.notific.ds_subcategoria === null ? '' : this.notific.ds_subcategoria + '-'
        this.notifica.titulo = this.notific.ds_categoria + '-' + sub + this.notific.titulo
        this.notifica.url_int = '/eventos/agenda-individual/' + this.notific.uuid
        //        this.loadMovims()
      })
      this.dialogFilterEvent = false
    },
    loadNotificacoes (item, mode) {
      const id = item.id
      const url = `${baseApiUrl}/notificacao-update/${id}`
      axios.get(url).then(res => {
        this.notifica = res.data
        this.codEvent = item.id
        this.codNotific = this.notifica.id
        this.data_do_evento = moment(this.notifica.data_evento).format('DD/MM/YYYY')
        this.fim_do_evento = moment(this.notifica.fim_evento).format('DD/MM/YYYY')
        this.notifica.data_evento = moment(this.notifica.data_evento).format('YYYY-MM-DD')
        this.notifica.fim_evento = moment(this.notifica.fim_evento).format('YYYY-MM-DD')
        //        this.loadMovims()
      })
      this.mode = mode
      this.dialogNotificacoes = true
    },

    filtroUnidades () {
      this.loadDpto()
      this.dialogFDpto = true
    },
    loadDpto () {
      const url = `${baseApiUrl}/unidades-com-agenda`
      axios.get(url).then(res => {
        this.listDptos = res.data
      })
    },
    loadUnidade (item) {
      this.departamento.uid_unidade = item.id
      this.cdDpto = item.id
      this.depto = item.unidade
      this.dialogFDpto = false
    },

     loadInactiveDpto (item) {
      this.menuunidade.id = item.id
      this.menuunidade.inativar = true
      this.updateDpto()
    },
    loadActiveDpto (item) {
      this.menuunidade.id = item.id
      this.menuunidade.inativar = false
      this.updateDpto()
    },
    loadDepartamentos () {
      const id = this.agenda.id
      const url = `${baseApiUrl}/unidades-agenda-update/${id}`
      axios.get(url).then(res => {
        this.departamentos = res.data
      })
    },
    addNotificacao () {
      this.dialogNotificacoes = true
    },
    closeDialog () {
      this.dialogNotificacoes = false
      this.notifica = {}
      this.data_do_evento = ''
      this.fim_do_evento = ''
    },
    loadMovim (item, mode) {
      const id = item.id
      const url = `${baseApiUrl}/movimento-da-agenda-select-update/${id}`
      axios.get(url).then(res => {
        this.movimento = res.data
        const idCat = this.movimento.uid_categoria
        if (!this.movimento.data) {
          this.data_cad = ''
        } else {
          this.data_cad = moment(this.movimento.data).format('DD/MM/YYYY')
          this.movimento.data = moment(this.movimento.data).format('YYYY-MM-DD')
        }
        if (!this.movimento.data_fim) {
          this.data_fim = ''
        } else {
          this.data_fim = moment(this.movimento.data_fim).format('DD/MM/YYYY')
          this.movimento.data_fim = moment(this.movimento.data_fim).format('YYYY-MM-DD')
        }
        this.loadSubCategorias(idCat)
      })
      this.mode = mode
      this.DialogMovimento = true
      this.loadCategorias()
    },
    loadDialog () {
      this.dialogFilter = true
      this.loadFilter()
      this.codigo = ''
    },
    loadDialogEvent () {
      this.dialogFilterEvent = true
      this.loadFilterEvent()
    },
    loadFilter () {
      const url = `${baseApiUrl}/agenda-filtro`
      axios.get(url).then(res => {
        this.agendas = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
      this.codigo = ''
    },
    loadFilterEvent () {
      const id = this.agenda.id
      const url = `${baseApiUrl}/movimento-da-agenda-filtro-notificacao/${id}`
      axios.get(url).then(res => {
        this.eventos = res.data.map(item => {
          return {
            ...item,
            inicio: moment(item.data).format('DD/MM/YYYY'),
            fim: moment(item.data_fim).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadMovimento () {
      const id = this.agenda.id
      const url = `${baseApiUrl}/movimento-por-id-agenda/${id}`
      axios.get(url).then(res => {
        this.movimentos = res.data.map(item => {
          return {
            ...item,
            datafim: moment(item.data_fim).format('DD/MM/YYYY'),
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadMeses () {
      const url = `${baseApiUrl}/meses-do-ano`
      axios.get(url).then(res => {
        this.meses = res.data.map(item => {
          return {
            value: item.nome,
            text: `${item.nome}`
          }
        })
      })
    },
    loadDiaSemana () {
      const url = `${baseApiUrl}/dias-da-semana`
      axios.get(url).then(res => {
        this.semana = res.data.map(item => {
          return {
            value: item.nome,
            text: `${item.nome}`
          }
        })
      })
    },
    loadCategorias () {
      const url = `${baseApiUrl}/categorias`
      axios.get(url).then(res => {
        this.categorias = res.data.map(cat => {
          return {
            value: cat.id,
            text: cat.categoria
          }
        })
      })
    },
    loadSubCategorias (idCat) {
      const uidCat = idCat || this.movimento.uid_categoria
      const url = `${baseApiUrl}/subcategorias-da-categoria/${uidCat}`
      axios.get(url).then(res => {
        this.subcategorias = res.data.map(subcat => {
          return {
            value: subcat.id,
            text: subcat.ds_subcategoria
          }
        })
      })
    },
    loadUsers () {
      this.agenda.usuario = this.user.id
    }
  },
  watch: {
    Filter () {
      // this.loadFilter()
    }
  },
  mounted () {
    this.loadMeses()
    this.loadDiaSemana()
    this.loadUsers()
    this.agenda.uuid = uuid.v1()
  }
}
</script>
<style scoped>
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-size--default {
  height: 37px !important;
  min-width: 38px !important;
}
</style>
